/* ============================================================
   MRC Cart Sync - global event-delegation for [data-mrc-quick-add]
   Updates: [data-mrc-cart-count] badges + cart-drawer (if present)
   Sets is-loading / is-success / is-error on the button.
   Dispatches CustomEvent 'mrc:cart:updated' with cart payload.
   ============================================================ */
(function() {
  if (window.__mrcCartSyncInit) return;
  window.__mrcCartSyncInit = true;

  const updateBadge = (cart) => {
    document.querySelectorAll('[data-mrc-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  };

  const mrcMoney = (c) => (c / 100).toFixed(2).replace('.', ',') + ' €';
  const mrcEsc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  const renderPreview = (cart) => {
    document.querySelectorAll('[data-mrc-cart-preview] .mrc-header__cart-preview-inner').forEach((inner) => {
      if (cart.item_count > 0) {
        const items = cart.items.slice(0, 3).map((it) => {
          const img = it.image ? '<img src="' + it.image + '" alt="" width="60" height="60">' : '';
          const title = mrcEsc((it.product_title || it.title || '').split(/\s+/).slice(0, 4).join(' '));
          return '<div class="mrc-header__cart-item"><div class="mrc-header__cart-item-img">' + img + '</div>'
            + '<div class="mrc-header__cart-item-body"><span class="mrc-header__cart-item-title">' + title + '</span>'
            + '<span class="mrc-header__cart-item-meta">' + it.quantity + ' × ' + mrcMoney(it.final_price) + '</span></div></div>';
        }).join('');
        const more = cart.items.length > 3 ? '<div class="mrc-header__cart-more">+ ' + (cart.items.length - 3) + ' weitere</div>' : '';
        inner.innerHTML = '<div class="mrc-header__cart-items">' + items + more + '</div>'
          + '<div class="mrc-header__cart-foot"><div class="mrc-header__cart-total"><span>Zwischensumme</span><strong>' + mrcMoney(cart.total_price) + '</strong></div>'
          + '<a href="/cart" class="mrc-header__cart-cta">Zum Warenkorb</a></div>';
      } else {
        inner.innerHTML = '<p class="mrc-header__cart-empty">Dein Warenkorb ist leer.</p>';
      }
    });
  };

  // Marken-Orange-Erinnerung: Quick-Buy bleibt orange, solange der Artikel
  // (Variante via data-mrc-quick-add bzw. Produkt via data-mrc-quick-modal) im Warenkorb liegt.
  let lastCart = null;
  const markInCart = (cart) => {
    const items = (cart && cart.items) ? cart.items : [];
    const variants = new Set(items.map((it) => String(it.id)));
    const handles  = new Set(items.map((it) => it.handle));
    document.querySelectorAll('[data-mrc-quick-add], [data-mrc-quick-modal]').forEach((btn) => {
      const v = btn.dataset.mrcQuickAdd;
      const h = btn.dataset.mrcQuickModal;
      const inCart = (v && variants.has(String(v))) || (h && handles.has(h));
      btn.classList.toggle('mrc-in-cart', !!inCart);
    });
    // Hero-Coverflow-Karten: eigener Button (.mrc-hero-cf__cart-btn) ohne data-mrc-quick-add.
    // Varianten-ID steckt im versteckten [data-mrc-cart-input], Groessen-Pills tragen [data-variant-id].
    // Karte = ein Produkt mit Groessen -> orange, wenn IRGENDEINE Variante im Korb liegt.
    document.querySelectorAll('.mrc-hero-cf__cart-btn').forEach((btn) => {
      const wrap = btn.closest('[data-mrc-card-wrap]') || btn.closest('form') || btn.parentElement;
      let inCart = false;
      if (wrap) {
        const inp = wrap.querySelector('[data-mrc-cart-input]');
        if (inp && inp.value && variants.has(String(inp.value))) inCart = true;
        if (!inCart) {
          wrap.querySelectorAll('[data-variant-id]').forEach((p) => {
            if (variants.has(String(p.dataset.variantId))) inCart = true;
          });
        }
      }
      btn.classList.toggle('mrc-in-cart', inCart);
    });
  };
  // Neu eingefuegte Buttons (Filter/Sortierung/Pagination der Collection) nachziehen.
  let __mrcReapplyRaf = 0;
  const setupInCartObserver = () => {
    if (window.__mrcInCartObserver || !document.body) return;
    const reapply = () => { __mrcReapplyRaf = 0; if (lastCart) markInCart(lastCart); };
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && ((n.matches && n.matches('[data-mrc-quick-add],[data-mrc-quick-modal],.mrc-hero-cf__cart-btn'))
              || (n.querySelector && n.querySelector('[data-mrc-quick-add],[data-mrc-quick-modal],.mrc-hero-cf__cart-btn')))) {
            if (!__mrcReapplyRaf) __mrcReapplyRaf = requestAnimationFrame(reapply);
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    window.__mrcInCartObserver = mo;
  };

  const applySections = (data) => {
    if (!data || !data.sections) return;
    const s = data.sections;
    if (s['cart-drawer']) {
      const tmp = document.createElement('div');
      tmp.innerHTML = s['cart-drawer'];
      const newD = tmp.querySelector('cart-drawer');
      const oldD = document.querySelector('cart-drawer');
      if (newD && oldD) oldD.replaceWith(newD);
    }
    if (s['cart-icon-bubble']) {
      const oldB = document.getElementById('cart-icon-bubble');
      if (oldB) oldB.innerHTML = s['cart-icon-bubble'];
    }
    if (s['cart-notification']) {
      const oldN = document.getElementById('cart-notification');
      if (oldN) oldN.innerHTML = s['cart-notification'];
    }
  };

  const refreshCart = async () => {
    try {
      const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
      updateBadge(cart);
      renderPreview(cart);
      lastCart = cart;
      markInCart(cart);
      document.dispatchEvent(new CustomEvent('mrc:cart:updated', { detail: cart }));
      return cart;
    } catch (_) { return null; }
  };


  /* ===== Variant-Picker Modal ===== */
  let modalEl = null;
  let modalTrigger = null;
  let modalText = {};
  const getModalText = (btn) => ({
    title: btn.dataset.mrcModalTitle || 'In den Warenkorb',
    choose: btn.dataset.mrcModalChoose || 'Größe auswählen',
    add: btn.dataset.mrcModalAdd || 'In den Warenkorb',
    close: btn.dataset.mrcModalClose || 'Auswahl schließen',
    unavailable: btn.dataset.mrcModalUnavailable || 'Im Zulauf',
    error: btn.dataset.mrcModalError || 'Varianten konnten nicht geladen werden.'
  });

  const setModalSelection = (pill) => {
    if (!modalEl || !pill || pill.disabled) return;
    modalEl.querySelectorAll('.mrc-vm__pill').forEach((item) => item.classList.toggle('is-active', item === pill));
    const addBtn = modalEl.querySelector('[data-mrc-vm-add]');
    const price = modalEl.querySelector('.mrc-vm__price');
    const addLabel = modalEl.querySelector('.mrc-vm__add-label');
    addBtn.disabled = false;
    addBtn.dataset.variantId = pill.dataset.variantId;
    price.textContent = pill.dataset.priceFormatted || '';
    addLabel.textContent = modalText.add + (pill.dataset.priceFormatted ? ' · ' + pill.dataset.priceFormatted : '');
  };

  const ensureModal = () => {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.id = 'mrc-variant-modal';
    modalEl.setAttribute('role', 'dialog');
    modalEl.setAttribute('aria-modal', 'true');
    modalEl.setAttribute('aria-labelledby', 'mrc-vm-heading');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML = `
      <div class="mrc-vm__backdrop" data-mrc-vm-close></div>
      <div class="mrc-vm__panel" role="document" tabindex="-1">
        <header class="mrc-vm__header">
          <h2 class="mrc-vm__heading" id="mrc-vm-heading"></h2>
          <button type="button" class="mrc-vm__close" data-mrc-vm-close></button>
        </header>
        <div class="mrc-vm__content">
          <div class="mrc-vm__media">
            <img class="mrc-vm__img" alt="">
          </div>
          <div class="mrc-vm__body">
            <h3 class="mrc-vm__title"></h3>
            <p class="mrc-vm__price" aria-live="polite"></p>
            <p class="mrc-vm__sub"></p>
            <div class="mrc-vm__variants" role="group"></div>
            <p class="mrc-vm__status" role="status" aria-live="polite"></p>
            <button type="button" class="mrc-vm__add" data-mrc-vm-add disabled>
              <span class="mrc-vm__add-bag" aria-hidden="true"></span>
              <span class="mrc-vm__add-label"></span>
            </button>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(modalEl);

    modalEl.addEventListener('click', (ev) => {
      if (ev.target.closest('[data-mrc-vm-close]')) {
        closeModal();
        return;
      }
      const pill = ev.target.closest('.mrc-vm__pill');
      if (pill && !pill.disabled) {
        setModalSelection(pill);
        return;
      }
      if (ev.target.closest('[data-mrc-vm-add]')) {
        const addBtn = modalEl.querySelector('[data-mrc-vm-add]');
        const vid = addBtn.dataset.variantId;
        if (!vid) return;
        addBtn.classList.add('is-loading');
        addBtn.disabled = true;
        const fakeBtn = document.createElement('button');
        fakeBtn.dataset.mrcQuickAdd = vid;
        handleQuickAdd(fakeBtn).then((added) => {
          if (added) {
            closeModal();
            return;
          }
          modalEl.querySelector('.mrc-vm__status').textContent = modalText.error;
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
        });
      }
    });

    document.addEventListener('keydown', (ev) => {
      if (modalEl.getAttribute('aria-hidden') !== 'false') return;
      if (ev.key === 'Escape') {
        closeModal();
        return;
      }
      if (ev.key !== 'Tab') return;
      const focusable = Array.from(modalEl.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (ev.shiftKey && document.activeElement === first) {
        ev.preventDefault();
        last.focus();
      } else if (!ev.shiftKey && document.activeElement === last) {
        ev.preventDefault();
        first.focus();
      }
    });

    return modalEl;
  };

  const openModal = async (btn) => {
    const handle = btn.dataset.mrcQuickModal;
    if (!handle) return;
    const modal = ensureModal();
    modalTrigger = btn;
    modalText = getModalText(btn);
    const heading = modal.querySelector('.mrc-vm__heading');
    const title = modal.querySelector('.mrc-vm__title');
    const price = modal.querySelector('.mrc-vm__price');
    const sub = modal.querySelector('.mrc-vm__sub');
    const variantsEl = modal.querySelector('.mrc-vm__variants');
    const status = modal.querySelector('.mrc-vm__status');
    const addBtn = modal.querySelector('[data-mrc-vm-add]');
    const addLabel = modal.querySelector('.mrc-vm__add-label');
    const closeBtn = modal.querySelector('.mrc-vm__close');
    const img = modal.querySelector('.mrc-vm__img');

    heading.textContent = modalText.title;
    title.textContent = btn.dataset.mrcProductTitle || '';
    price.textContent = '';
    sub.textContent = modalText.choose;
    variantsEl.setAttribute('aria-label', modalText.choose);
    variantsEl.innerHTML = '';
    status.textContent = '';
    addBtn.disabled = true;
    addBtn.classList.remove('is-loading');
    delete addBtn.dataset.variantId;
    addLabel.textContent = modalText.add;
    closeBtn.setAttribute('aria-label', modalText.close);
    img.src = btn.dataset.mrcProductImg || '';
    img.alt = btn.dataset.mrcProductTitle || '';
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.mrc-vm__panel').focus();

    try {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const r = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } });
      if (!r.ok) throw new Error('product request failed');
      const product = await r.json();
      title.textContent = product.title;
      img.src = btn.dataset.mrcProductImg || product.featured_image;
      img.alt = product.title;
      const fmtPrice = (cents) => (cents/100).toFixed(2).replace('.', ',') + ' €';
      const includeBulkVariant = handle === 'kurkuma-pulver';
      const visibleVariants = product.variants.filter(v => {
        const w = v.weight || v.grams || 0;
        return includeBulkVariant || w < 1000;
      });
      const renderList = visibleVariants.length ? visibleVariants : product.variants;
      if (product.options && product.options[0] && product.options[0].name && product.options[0].name !== 'Title') {
        sub.textContent = product.options[0].name + ' auswählen';
        variantsEl.setAttribute('aria-label', sub.textContent);
      }
      renderList.forEach(v => {
        const pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'mrc-vm__pill';
        pill.dataset.variantId = v.id;
        pill.dataset.price = v.price;
        pill.dataset.priceFormatted = fmtPrice(v.price);
        let label = v.title;
        const w = v.weight || v.grams || 0;
        if (label === 'Default Title' || !label) {
          if (w >= 1000) label = (w/1000) + ' kg';
          else if (w > 0) label = w + ' g';
        } else {
          label = label.replace(/(\d+)([gk])/i, '$1 $2');
        }
        const labelEl = document.createElement('span');
        labelEl.className = 'mrc-vm__pill-label';
        labelEl.textContent = label;
        const priceEl = document.createElement('span');
        priceEl.className = 'mrc-vm__pill-price';
        priceEl.textContent = v.available ? fmtPrice(v.price) : modalText.unavailable;
        pill.append(labelEl, priceEl);
        if (!v.available) {
          pill.disabled = true;
          pill.setAttribute('aria-label', label + ' - ' + modalText.unavailable);
        }
        variantsEl.appendChild(pill);
      });
      const firstPill = variantsEl.querySelector('.mrc-vm__pill:not([disabled])');
      if (firstPill) {
        setModalSelection(firstPill);
      } else {
        addBtn.disabled = true;
        addLabel.textContent = modalText.unavailable;
      }
    } catch (e) {
      console.error('[mrc-modal]', e);
      status.textContent = modalText.error;
      addBtn.disabled = true;
    }
  };

  const closeModal = () => {
    if (!modalEl) return;
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (modalTrigger) modalTrigger.focus();
  };

  /* ===== Zulauf-Hinweis für bewusst noch nicht kaufbare Produkte ===== */
  let incomingModalEl = null;
  let incomingTrigger = null;

  const incomingDefaults = () => {
    const isGerman = (document.documentElement.lang || '').toLowerCase().startsWith('de');
    return isGerman
      ? {
          eyebrow: 'Verfügbarkeit',
          title: 'Produkt im Zulauf',
          body: 'Dieses Produkt befindet sich im Zulauf und ist aktuell noch nicht bestellbar.',
          note: 'Preis und Verkaufsstart folgen.',
          close: 'Verstanden',
          dismiss: 'Dialog schließen'
        }
      : {
          eyebrow: 'Availability',
          title: 'Product coming soon',
          body: 'This product is on its way and cannot be ordered yet.',
          note: 'Price and launch date will follow.',
          close: 'Got it',
          dismiss: 'Close dialog'
        };
  };

  const closeIncomingModal = () => {
    if (!incomingModalEl) return;
    incomingModalEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (incomingTrigger) incomingTrigger.focus();
  };

  const ensureIncomingModal = () => {
    if (incomingModalEl) return incomingModalEl;
    incomingModalEl = document.createElement('div');
    incomingModalEl.id = 'mrc-incoming-modal';
    incomingModalEl.setAttribute('role', 'dialog');
    incomingModalEl.setAttribute('aria-modal', 'true');
    incomingModalEl.setAttribute('aria-labelledby', 'mrc-incoming-heading');
    incomingModalEl.setAttribute('aria-hidden', 'true');
    incomingModalEl.innerHTML = `
      <div class="mrc-incoming__backdrop" data-mrc-incoming-close></div>
      <div class="mrc-incoming__panel" role="document" tabindex="-1">
        <button type="button" class="mrc-incoming__close" data-mrc-incoming-close></button>
        <p class="mrc-incoming__eyebrow"></p>
        <h2 class="mrc-incoming__heading" id="mrc-incoming-heading"></h2>
        <p class="mrc-incoming__product"></p>
        <p class="mrc-incoming__body"></p>
        <p class="mrc-incoming__note"></p>
        <button type="button" class="mrc-incoming__confirm" data-mrc-incoming-close></button>
      </div>
    `;
    document.body.appendChild(incomingModalEl);

    incomingModalEl.addEventListener('click', (ev) => {
      if (ev.target.closest('[data-mrc-incoming-close]')) closeIncomingModal();
    });

    document.addEventListener('keydown', (ev) => {
      if (incomingModalEl.getAttribute('aria-hidden') !== 'false') return;
      if (ev.key === 'Escape') {
        closeIncomingModal();
        return;
      }
      if (ev.key !== 'Tab') return;
      const focusable = Array.from(incomingModalEl.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (ev.shiftKey && document.activeElement === first) {
        ev.preventDefault();
        last.focus();
      } else if (!ev.shiftKey && document.activeElement === last) {
        ev.preventDefault();
        first.focus();
      }
    });

    return incomingModalEl;
  };

  const openIncomingModal = (btn) => {
    const modal = ensureIncomingModal();
    const defaults = incomingDefaults();
    incomingTrigger = btn;
    modal.querySelector('.mrc-incoming__eyebrow').textContent = defaults.eyebrow;
    modal.querySelector('.mrc-incoming__heading').textContent = btn.dataset.mrcComingTitle || defaults.title;
    modal.querySelector('.mrc-incoming__product').textContent = btn.dataset.mrcProductTitle || '';
    modal.querySelector('.mrc-incoming__body').textContent = btn.dataset.mrcComingBody || defaults.body;
    modal.querySelector('.mrc-incoming__note').textContent = btn.dataset.mrcComingNote || defaults.note;
    const closeLabel = btn.dataset.mrcComingClose || defaults.close;
    const dismissLabel = btn.dataset.mrcComingDismiss || defaults.dismiss;
    modal.querySelector('.mrc-incoming__close').setAttribute('aria-label', dismissLabel);
    modal.querySelector('.mrc-incoming__confirm').textContent = closeLabel;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.mrc-incoming__panel').focus();
  };

  const handleQuickAdd = async (btn) => {
    const variantId = btn.dataset.mrcQuickAdd || btn.dataset.variant;
    if (!variantId) return false;
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-success')) return false;
    btn.classList.add('is-loading');
    try {
      const route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
      const r = await fetch(route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble', 'cart-notification'],
          sections_url: window.location.pathname
        })
      });
      const data = await r.json();
      if (!r.ok || data.status >= 400) {
        throw new Error(data.description || data.message || 'add failed');
      }
      applySections(data);
      await refreshCart();
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      var addedLabel = (data && (data.product_title || data.title)) || '';
      showToast(addedLabel ? addedLabel + ' im Warenkorb' : 'Im Warenkorb');
      /* Wenn wir auf der Cart-Page sind, müssen Cart-Items oben neu rendern (nach Toast) */
      if (window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart')) {
        setTimeout(() => { window.location.reload(); }, 1600);
        return true;
      }
      setTimeout(() => btn.classList.remove('is-success'), 1800);
      return true;
    } catch (err) {
      console.error('[mrc-cart-sync]', err);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      setTimeout(() => btn.classList.remove('is-error'), 1800);
      return false;
    }
  };

  document.addEventListener('click', (e) => {
    const incomingBtn = e.target.closest('[data-mrc-coming-soon]');
    if (incomingBtn) {
      e.preventDefault();
      e.stopPropagation();
      openIncomingModal(incomingBtn);
      return;
    }
    /* Modal-Trigger zuerst */
    const modalBtn = e.target.closest('[data-mrc-quick-modal]');
    if (modalBtn) {
      e.preventDefault();
      e.stopPropagation();
      openModal(modalBtn);
      return;
    }
    const btn = e.target.closest('[data-mrc-quick-add], [data-mrc-fbt-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleQuickAdd(btn);
  }, true);

  // === Toast === (dezente Push-Nachricht oben rechts)
  const injectToastCSS = () => {
    if (document.getElementById('mrc-cart-toast-css')) return;
    const s = document.createElement('style');
    s.id = 'mrc-cart-toast-css';
    s.textContent = ''
      + '.mrc-cart-toast{position:fixed;top:88px;right:20px;max-width:calc(100vw - 40px);'
      + 'display:inline-flex;align-items:center;gap:8px;padding:11px 16px 11px 13px;'
      + 'background:#2b783c;color:#fff;border-radius:999px;'
      + "font:600 13px/1.2 'Inter',system-ui,sans-serif;letter-spacing:.01em;"
      + 'box-shadow:0 12px 32px rgba(26,23,20,.18),0 2px 8px rgba(43,120,60,.25);'
      + 'opacity:0;transform:translateY(-10px) scale(.96);pointer-events:none;'
      + 'transition:opacity .26s cubic-bezier(.2,.7,.2,1),transform .26s cubic-bezier(.2,.7,.2,1);'
      + 'z-index:99999}'
      + '.mrc-cart-toast.is-show{opacity:1;transform:translateY(0) scale(1)}'
      + '.mrc-cart-toast__icon{display:inline-flex;align-items:center;justify-content:center;'
      + 'width:20px;height:20px;border-radius:50%;background:rgba(255,255,255,.18)}'
      + '.mrc-cart-toast__text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:60vw}'
      + '@media(max-width:480px){.mrc-cart-toast{top:calc(env(safe-area-inset-top, 0px) + 84px);bottom:auto;right:16px;left:16px;'
      + 'justify-content:center;padding:12px 16px;font-size:13.5px;border-radius:14px}}';
    document.head.appendChild(s);
  };
  injectToastCSS();

  const ensureToast = () => {
    let t = document.querySelector('.mrc-cart-toast');
    if (t) return t;
    t = document.createElement('div');
    t.className = 'mrc-cart-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.innerHTML = '<span class="mrc-cart-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
      '</span><span class="mrc-cart-toast__text">Im Warenkorb</span>';
    document.body.appendChild(t);
    return t;
  };
  const showToast = (label) => {
    const t = ensureToast();
    const txt = t.querySelector('.mrc-cart-toast__text');
    if (txt) txt.textContent = label || 'Im Warenkorb';
    t.classList.add('is-show');
    clearTimeout(t.__mrcTimer);
    t.__mrcTimer = setTimeout(() => t.classList.remove('is-show'), 2400);
  };

  // === Universal Add-to-Cart Form-Hijack ===
  // Faengt JEDES Form mit action=/cart/add (Dawn-Defaults + mrc-product-hero + mrc-hero-coverflow).
  // Verhindert die Server-Redirection zu /cart, sendet AJAX, aktualisiert Counter + Toast.
  const handleFormSubmit = async (form) => {
    const btn = form.querySelector('[type="submit"]');
    if (btn && btn.dataset.mrcBusy === '1') return;
    if (btn) {
      btn.dataset.mrcBusy = '1';
      btn.classList.add('is-loading');
    }
    let productLabel = '';
    try {
      const fd = new FormData(form);
      const route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';
      const r = await fetch(route, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      const data = await r.json();
      if (!r.ok || (data && data.status && data.status >= 400)) {
        throw new Error((data && (data.description || data.message)) || 'add failed');
      }
      productLabel = (data && (data.product_title || data.title)) || '';
      await refreshCart();
      showToast(productLabel ? productLabel + ' im Warenkorb' : 'Im Warenkorb');
      if (btn) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        setTimeout(() => btn.classList.remove('is-success'), 1800);
      }
    } catch (err) {
      console.error('[mrc-cart-sync] form add error:', err);
      if (btn) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setTimeout(() => btn.classList.remove('is-error'), 1800);
      }
      showToast('Konnte nicht hinzufuegen');
    } finally {
      if (btn) delete btn.dataset.mrcBusy;
    }
  };

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleFormSubmit(form);
  }, true);

  // === Globaler fetch-Hook fuer /cart/change /cart/update /cart/clear ===
  // Stellt sicher, dass nach Quantity-Aenderungen auf der /cart-Seite das
  // Header-Bubble [data-mrc-cart-count] aktuell bleibt - auch wenn das
  // Dawn-cart.js die cart-icon-bubble Section nicht finden kann.
  if (!window.__mrcGlobalCartFetchHook) {
    window.__mrcGlobalCartFetchHook = true;
    const origFetch = window.fetch.bind(window);
    window.fetch = function (...args) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      const isCartChange = typeof url === 'string' && (
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      );
      const p = origFetch(...args);
      if (isCartChange) {
        p.then(() => { setTimeout(refreshCart, 100); }).catch(() => {});
      }
      return p;
    };
  }

  // Initial Badge-Sync (falls cart != 0 von Server-Cache abweicht)
  if (document.readyState !== 'loading') { refreshCart(); setupInCartObserver(); }
  else document.addEventListener('DOMContentLoaded', () => { refreshCart(); setupInCartObserver(); }, { once: true });
})();
